// Vuex root store setup with namespaced modules
import { createStore } from 'vuex'
import auth from './modules/auth'
import agreement from './modules/agreement'
import gallery from './modules/gallery'
import branches from './modules/branches'
import header from './modules/header'
import hero from './modules/hero'
import products from './modules/products'
import testimonials from './modules/testimonials'
import staff from './modules/staff'
import purchases from './modules/purchases'
import sales from './modules/sales'
import saleInvoice from './modules/saleInvoice'
import expenses from './modules/expenses'
import accountSheets from './modules/accountSheets'
import accountants from './modules/accountants'
import contactMessages from './modules/contactMessages'

const store = createStore({
  modules: {
    auth,
    agreement,
    gallery,
    branches,
    header,
    hero,
    products,
    testimonials,
    staff,
    purchases,
    sales,
    saleInvoice,
    expenses,
    accountSheets,
    accountants,
    contactMessages
  }
})

export default store
